/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssanimations-cssgrid_cssgridlegacy-csspositionsticky-csstransforms-csstransitions-hashchange-localstorage-postmessage-svgasimg-touchevents-prefixed-prefixedcss-setclasses !*/
!function (e, t, n) {
  function r(e, t) {
    return typeof e === t
  }

  function o() {
    var e, t, n, o, i, s, a;
    for (var u in w) if (w.hasOwnProperty(u)) {
      if (e = [], t = w[u], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
      for (o = r(t.fn, "function") ? t.fn() : t.fn, i = 0; i < e.length; i++) s = e[i], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = o : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = o), C.push((o ? "" : "no-") + a.join("-"))
    }
  }

  function i(e) {
    var t = T.className, n = Modernizr._config.classPrefix || "";
    if (b && (t = t.baseVal), Modernizr._config.enableJSClass) {
      var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
      t = t.replace(r, "$1" + n + "js$2")
    }
    Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), b ? T.className.baseVal = t : T.className = t)
  }

  function s() {
    return "function" != typeof t.createElement ? t.createElement(arguments[0]) : b ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
  }

  function a(e) {
    return e.replace(/([a-z])-([a-z])/g, function (e, t, n) {
      return t + n.toUpperCase()
    }).replace(/^-/, "")
  }

  function u(e) {
    return e.replace(/([A-Z])/g, function (e, t) {
      return "-" + t.toLowerCase()
    }).replace(/^ms-/, "-ms-")
  }

  function l(e, t) {
    if ("object" == typeof e) for (var n in e) P(e, n) && l(n, e[n]); else {
      e = e.toLowerCase();
      var r = e.split("."), o = Modernizr[r[0]];
      if (2 == r.length && (o = o[r[1]]), "undefined" != typeof o) return Modernizr;
      t = "function" == typeof t ? t() : t, 1 == r.length ? Modernizr[r[0]] = t : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = t), i([(t && 0 != t ? "" : "no-") + r.join("-")]), Modernizr._trigger(e, t)
    }
    return Modernizr
  }

  function f(e, t) {
    return !!~("" + e).indexOf(t)
  }

  function c(e, t) {
    return function () {
      return e.apply(t, arguments)
    }
  }

  function d(e, t, n) {
    var o;
    for (var i in e) if (e[i] in t) return n === !1 ? e[i] : (o = t[e[i]], r(o, "function") ? c(o, n || t) : o);
    return !1
  }

  function p() {
    var e = t.body;
    return e || (e = s(b ? "svg" : "body"), e.fake = !0), e
  }

  function m(e, n, r, o) {
    var i, a, u, l, f = "modernizr", c = s("div"), d = p();
    if (parseInt(r, 10)) for (; r--;) u = s("div"), u.id = o ? o[r] : f + (r + 1), c.appendChild(u);
    return i = s("style"), i.type = "text/css", i.id = "s" + f, (d.fake ? d : c).appendChild(i), d.appendChild(c), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(t.createTextNode(e)), c.id = f, d.fake && (d.style.background = "", d.style.overflow = "hidden", l = T.style.overflow, T.style.overflow = "hidden", T.appendChild(d)), a = n(c, e), d.fake ? (d.parentNode.removeChild(d), T.style.overflow = l, T.offsetHeight) : c.parentNode.removeChild(c), !!a
  }

  function g(t, n, r) {
    var o;
    if ("getComputedStyle" in e) {
      o = getComputedStyle.call(e, t, n);
      var i = e.console;
      if (null !== o) r && (o = o.getPropertyValue(r)); else if (i) {
        var s = i.error ? "error" : "log";
        i[s].call(i, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
      }
    } else o = !n && t.currentStyle && t.currentStyle[r];
    return o
  }

  function h(t, r) {
    var o = t.length;
    if ("CSS" in e && "supports" in e.CSS) {
      for (; o--;) if (e.CSS.supports(u(t[o]), r)) return !0;
      return !1
    }
    if ("CSSSupportsRule" in e) {
      for (var i = []; o--;) i.push("(" + u(t[o]) + ":" + r + ")");
      return i = i.join(" or "), m("@supports (" + i + ") { #modernizr { position: absolute; } }", function (e) {
        return "absolute" == g(e, null, "position")
      })
    }
    return n
  }

  function v(e, t, o, i) {
    function u() {
      c && (delete L.style, delete L.modElem)
    }

    if (i = r(i, "undefined") ? !1 : i, !r(o, "undefined")) {
      var l = h(e, o);
      if (!r(l, "undefined")) return l
    }
    for (var c, d, p, m, g, v = ["modernizr", "tspan", "samp"]; !L.style && v.length;) c = !0, L.modElem = s(v.shift()), L.style = L.modElem.style;
    for (p = e.length, d = 0; p > d; d++) if (m = e[d], g = L.style[m], f(m, "-") && (m = a(m)), L.style[m] !== n) {
      if (i || r(o, "undefined")) return u(), "pfx" == t ? m : !0;
      try {
        L.style[m] = o
      } catch (y) {
      }
      if (L.style[m] != g) return u(), "pfx" == t ? m : !0
    }
    return u(), !1
  }

  function y(e, t, n, o, i) {
    var s = e.charAt(0).toUpperCase() + e.slice(1), a = (e + " " + j.join(s + " ") + s).split(" ");
    return r(t, "string") || r(t, "undefined") ? v(a, t, o, i) : (a = (e + " " + N.join(s + " ") + s).split(" "), d(a, t, n))
  }

  function _(e, t, r) {
    return y(e, n, n, t, r)
  }

  var C = [], w = [], S = {
    _version: "3.6.0",
    _config: {classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0},
    _q: [],
    on: function (e, t) {
      var n = this;
      setTimeout(function () {
        t(n[e])
      }, 0)
    },
    addTest: function (e, t, n) {
      w.push({name: e, fn: t, options: n})
    },
    addAsyncTest: function (e) {
      w.push({name: null, fn: e})
    }
  }, Modernizr = function () {
  };
  Modernizr.prototype = S, Modernizr = new Modernizr, Modernizr.addTest("postmessage", "postMessage" in e);
  var x = S._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
  S._prefixes = x;
  var T = t.documentElement, b = "svg" === T.nodeName.toLowerCase();
  Modernizr.addTest("csspositionsticky", function () {
    var e = "position:", t = "sticky", n = s("a"), r = n.style;
    return r.cssText = e + x.join(t + ";" + e).slice(0, -e.length), -1 !== r.position.indexOf(t)
  });
  var z = function () {
    function e(e, t) {
      var o;
      return e ? (t && "string" != typeof t || (t = s(t || "div")), e = "on" + e, o = e in t, !o && r && (t.setAttribute || (t = s("div")), t.setAttribute(e, ""), o = "function" == typeof t[e], t[e] !== n && (t[e] = n), t.removeAttribute(e)), o) : !1
    }

    var r = !("onblur" in t.documentElement);
    return e
  }();
  S.hasEvent = z, Modernizr.addTest("hashchange", function () {
    return z("hashchange", e) === !1 ? !1 : t.documentMode === n || t.documentMode > 7
  }), Modernizr.addTest("localstorage", function () {
    var e = "modernizr";
    try {
      return localStorage.setItem(e, e), localStorage.removeItem(e), !0
    } catch (t) {
      return !1
    }
  });
  var P;
  !function () {
    var e = {}.hasOwnProperty;
    P = r(e, "undefined") || r(e.call, "undefined") ? function (e, t) {
      return t in e && r(e.constructor.prototype[t], "undefined")
    } : function (t, n) {
      return e.call(t, n)
    }
  }(), S._l = {}, S.on = function (e, t) {
    this._l[e] || (this._l[e] = []), this._l[e].push(t), Modernizr.hasOwnProperty(e) && setTimeout(function () {
      Modernizr._trigger(e, Modernizr[e])
    }, 0)
  }, S._trigger = function (e, t) {
    if (this._l[e]) {
      var n = this._l[e];
      setTimeout(function () {
        var e, r;
        for (e = 0; e < n.length; e++) (r = n[e])(t)
      }, 0), delete this._l[e]
    }
  }, Modernizr._q.push(function () {
    S.addTest = l
  }), Modernizr.addTest("svgasimg", t.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1"));
  var E = "Moz O ms Webkit", j = S._config.usePrefixes ? E.split(" ") : [];
  S._cssomPrefixes = j;
  var A = function (t) {
    var r, o = x.length, i = e.CSSRule;
    if ("undefined" == typeof i) return n;
    if (!t) return !1;
    if (t = t.replace(/^@/, ""), r = t.replace(/-/g, "_").toUpperCase() + "_RULE", r in i) return "@" + t;
    for (var s = 0; o > s; s++) {
      var a = x[s], u = a.toUpperCase() + "_" + r;
      if (u in i) return "@-" + a.toLowerCase() + "-" + t
    }
    return !1
  };
  S.atRule = A;
  var N = S._config.usePrefixes ? E.toLowerCase().split(" ") : [];
  S._domPrefixes = N;
  var O = S.testStyles = m;
  Modernizr.addTest("touchevents", function () {
    var n;
    if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0; else {
      var r = ["@media (", x.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
      O(r, function (e) {
        n = 9 === e.offsetTop
      })
    }
    return n
  });
  var k = {elem: s("modernizr")};
  Modernizr._q.push(function () {
    delete k.elem
  });
  var L = {style: k.elem.style};
  Modernizr._q.unshift(function () {
    delete L.style
  }), S.testAllProps = y;
  var R = S.prefixed = function (e, t, n) {
    return 0 === e.indexOf("@") ? A(e) : (-1 != e.indexOf("-") && (e = a(e)), t ? y(e, t, n) : y(e, "pfx"))
  };
  S.prefixedCSS = function (e) {
    var t = R(e);
    return t && u(t)
  };
  S.testAllProps = _, Modernizr.addTest("cssanimations", _("animationName", "a", !0)), Modernizr.addTest("cssgridlegacy", _("grid-columns", "10px", !0)), Modernizr.addTest("cssgrid", _("grid-template-rows", "none", !0)), Modernizr.addTest("csstransforms", function () {
    return -1 === navigator.userAgent.indexOf("Android 2.") && _("transform", "scale(1)", !0)
  }), Modernizr.addTest("csstransitions", _("transition", "all", !0)), o(), i(C), delete S.addTest, delete S.addAsyncTest;
  for (var q = 0; q < Modernizr._q.length; q++) Modernizr._q[q]();
  e.Modernizr = Modernizr
}(window, document);


/**
 *  Tracks JS errors and sends a report to the server.
 */
(function ($, window) {

  function trackError(error, fieldsObj) {

    var errorDefaults = {
        event_category: 'Script',
        event_action: 'error',
        description: (error && error.stack) || '(not set)',
        nonInteraction: true
      },
      options = $.extend(errorDefaults, fieldsObj);

    if (typeof gtag !== 'undefined') gtag('event', 'exception', options);

  }

  function trackErrors() {

    var loadErrorEvents = window.__e && window.__e.q || [],
      fieldsObj = {
        event_action: 'uncaught error'
      };

    // Replay any stored load error events.
    for (var index in loadErrorEvents) {

      trackError(loadErrorEvents[index].error, fieldsObj);

    }

    // Add a new listener to track event immediately.
    window.addEventListener('error', function (event) {

      trackError(event.error, fieldsObj);

    });

  }

  $(trackErrors);

  window.onerror = function (message, source, lineno, colno, error) {

    if (typeof message === 'undefined') var message = '';
    if (typeof source === 'undefined') var source = '';
    if (typeof lineno === 'undefined') var lineno = 0;
    if (typeof colno === 'undefined') var colno = 0;

    var stack = '';

    if (typeof error === 'object' && typeof error.stack === 'string') stack = error.stack;

    $.ajax({
      url: '/library/api/capture-js-error.php',
      type: 'post',
      dataType: 'json',
      data: {
        je_message: message,
        je_source: source,
        je_lineno: lineno,
        je_colno: colno,
        je_url: window.location.href,
        je_stack: stack
      }
    });

  };

})(jQuery, window);


//add global easing method
jQuery.easing['jswing'] = jQuery.easing['swing'];
jQuery.extend(jQuery.easing,
  {
    easeInCubic: function (x, t, b, c, d) {
      return c * (t /= d) * t * t + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
      return c * ((t = t / d - 1) * t * t + 1) + b;
    },
    easeInOutCubic: function (x, t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    },
    easeInQuad: function (x, t, b, c, d) {
      return c * (t /= d) * t + b;
    },
    easeOutQuad: function (x, t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },
    easeInOutQuad: function (x, t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t + b;
      return -c / 2 * ((--t) * (t - 2) - 1) + b;
    }
  });


if (!('onCSSTransitionEnd' in $.fn)) {

  (function ($, window, document, undefined) {

    if (typeof $.fn.onCSSTransitionEnd === 'function') return;

    var s = document.body || document.documentElement, s = s.style, prefixAnimation = '', prefixTransition = '',
      eventAnimation = 'animationend', eventTransition = 'transitionend',
      transEndEventNames = {
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'transition': 'transitionend'
      },
      transEndEventName = transEndEventNames[Modernizr.prefixed('transition')],
      transCSS = Modernizr.prefixedCSS('transition');

    $.fn.extend({
      onCSSAnimationEnd: function (callback) {

        var $this = $(this);

        $this.one(eventAnimation, callback);

        if ((prefixAnimation == '' && !('animation' in s)) || $this.css(prefixAnimation + 'animation-duration') == '0s') $.each($this, callback);

        return this;

      },
      onCSSTransitionEnd: function (callback) {

        var $this = $(this);

        if (typeof transEndEventName !== 'string' || ($this.css(transCSS + '-duration') === '0s' && $this.css(transCSS + '-delay') === '0s')) {

          $.each($this, callback);

        } else {

          $this.one(eventTransition, callback);

        }

        return this;

      }
    });
  })(jQuery, window, document);

}


/*!
 * Copyright (C) 2013-2025, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 * PeppermillReno.com Custom JS - 3/4/2013
 * Version: 1.6.1
 * Changes:
 *		2016-02-25
 *			- Initial Install
 *
 *		2016-08-02
 *			- Added code for fullscreen button in the gallery.
 *
 *		2016-08-03
 *			- Gallery images now don't display larger than their actual size.
 *			- Query-string data is now discarded when checking if URLs patch when changing pages.
 *
 *		2017-01-06 (1.1.1)
 *			- When using PRIVLINE offer code in Reservation Widget, a company code is required to be forwarded to ResNet.
 *				- A dialog is used to gather this information.
 *			- Fixed GA Linker for links that point to /offers and /choose-a-room as well as the Header Reseration Widget
 *
 *		2017-01-17 (1.1.2)
 *			- If a menu iframe does not load in 10 seconds, a dialog will appear asking if the user wants to directly download the PDF.
 *				- This is to get around the corporate network blocking Google Drive.
 *
 *		2017-01-23 (1.1.3)
 *			- Videos are paused when the reservations/login/menu overlays are visible.
 *
 *		2017-01-25 (1.1.4)
 *			- Menus are now loaded as a PDF by default for non touch-enabled devices and for devices on the corporate network.
 *			- The Outlet Hours API is not hit unless there are potential .item matches on the page.
 *			- Dialogs shown with pepvalidate-v3 forms will now correctly submit the dialog rather than the pepvalidate-v3 form when <ENTER> is pressed inside an input or textarea.
 *
 *		2017-01-30 (1.1.5)
 *			- Removed CSRF_TOKEN and honeypot from search queries.
 *
 *		2017-01-31 (1.1.6)
 *			- Added code to handle table pagination.
 *
 *		2017-02-14 (1.1.7)
 *			- Passport Header login successes and failures now send event tracking beacons.
 *
 *		2017-02-21 (1.1.8)
 *			- Updated Confirmation Dialogs for better accessibility via tabindex.
 *			- Fixed various bugs in page link filters.
 *			- Page link filters now adjust the count for each option when opening a flyout menu.
 *
 *		2017-03-03 (1.1.9)
 *			- Updated video controls.
 *			- Fixed positioning of artwork dot overlays when not shown full-width.
 *
 *		2017-03-06 (1.1.10)
 *			- Flash video tech now loads in wmode transparent with a transparent background so there's no flash of black before the video plays.
 *
 *		2017-03-31 (1.1.11)
 *			- Fixed outlet hours not appending to .item h3 titles because the .clip span had been removed.
 *
 *		2017-06-27 (1.1.12)
 *			- Fixed issue with the footer opacity as it's first being shown.
 *
 *		2017-07-11 (1.1.13)
 *			- Changes to inputs in the reservation widget in the header are now saved across page loads for 30 minutes.
 *
 *		2017-07-18 (1.1.14)
 *			- Added code to redirect to WiFi portal for wifi nav link.
 *
 *		2017-09-12 (1.1.15)
 *			- Updated .page-link-subnav link clicks to reset focus on section header for accessibility.
 *			- Do not show outlet hour notifications for .related-event page links.
 *			- Fixed issue with related event iframes not being resized in Firefox.
 *
 *		2018-01-11 (1.1.16)
 *			- Subnav link clicks are now tracked in GA.
 *
 *		2018-02-21 (1.1.17)
 *			- Default check-in date is now today, rather than tomorrow.
 *
 *		2018-05-11 (1.1.18)
 *			- Fixed styling of input in popup for booking a PRIVLINE offer via the header.
 *
 *		2018-06-11 (1.1.19)
 *			- Added back-to-top code.
 *
 *		2018-12-04 (1.1.20)
 *			- Fixed loading spinner for #artwork play/pause buttons so mobile devices don't show the spinner before interacting with the widget.
 *
 *		2019-02-18 (1.1.21)
 *			- Updated to VideoJS 7.5.0.
 *
 *		2019-04-03 (1.1.22)
 *			- Created new pepSlideshow object to handle multiple slideshows on a page.
 *			- Slideshow videos now play/pause if they go into our out of view due to scrolling.
 *
 *		2019-05-17 (1.1.23)
 *			- Added resolution tracking in GA for HLS videos.
 *
 *		2019-06-13 (1.1.24)
 *			- Fixed bug with SVG sprites not loading when the pepsprites cookie existed but had a blank value.
 *
 *		2019-08-19 (1.1.25)
 *			- Page link group expanded state is now saved across page loads.
 *			- Videos now use the Vimeo Player SDK rather than VideoJS.
 *
 *		2020-02-13 (1.1.26)
 *			- Removed wifi nav link code.
 *
 *		2020-08-05 (1.1.27)
 *			- Updated window.getReservationSelections() to not return invalid check in/out dates.
 *			- Replaced Modernizr.localstorage checks with 'localStorage' in window.
 *
 *		2021-01-12 (1.1.28)
 *			- Updated window.pepHelperFunctions.getParameterByName to return an array of values when the parameter is a GET array.
 *
 *		2021-10-15 (1.2.0)
 *			- All references to pepvalidate functions are preceded by "window."
 *
 *		2021-10-27 (1.2.1)
 *			- window.getReservationSelections() now correctly calculates date differences.
 *			- All references to pepvalidate functions are preceded by "window."
 *
 *		2021-11-04 (1.2.2) (zsahs)
 *			-Created function to target buttons with href="manage-reservations" and append ga data to their href value.
 *
 *		2022-02-08 (1.2.3) (zsahs)
 * 			-Function created to target buttons in 1.2.2 has been converted to a click event handler.
 *			 GA information is only gathered and appended to URL when button is clicked.
 *
 *		2022-08-05 (1.3.0)
 *			- Refactor window.getReservationSelections() to hotelRoomsVueApp.getReservationSelections().
 *			- Refactor window.saveReservationSelections() to hotelRoomsVueApp.saveReservationSelections().
 *			- Save offsetTop and height for page link items in dataset as well as $.data().
 *
 *		2023-05-25 (1.4.0) (jhoward)
 *			- Migrate main.js to gtag() from ga().
 *
 *		2023-07-13 (1.4.1) (jhoward)
 *			- Setup pepTracking.getGA4LinkerParam() helper method to get GA4 linker parameter.
 *
 *		2023-11-22 (1.5.0) (jhoward)
 *			- Refactor pepDateFunctions and pepHelperFunctions from main.js to their own JS files.
 *
 *		2024-06-10 (1.6.0) (jhoward)
 *			- Remove unused code from main.js.
 *			- Refactor dialog code from main.js to Vue component.
 *			- Refactor external link warning code from main.js to Vue component.
 *			- Add aria and role attributes to toast notifications in main.js.
 *			- Accessibility modifications to footer award logo slideshow in main.js.
 *
 *		2025-03-13 (1.6.1) (jhoward)
 *			- Add validation to related event iframe message handler in main.js.
 *			- Hide related events content area if no related events are being displayed in main.js.
 */

window.pepWindowLoad = false;
jQuery(window).on("load", function () {
  window.pepWindowLoad = true;
});

(function ($) {

  let maxHeaderHeight = {
    mobile: 60,
    desktop: 75
  };
  let lastRenderedScroll;

  function savePageSetting(settingKey, settingValue) {

    var pageID = $('body').data('i');

    if (pageID && parseInt(pageID, 10)) {

      var settings = getPageSettings();	//store for 16 hours max

      if ('object' !== typeof settings) {

        settings = {};

      }

      settings[settingKey] = settingValue;

      pepHelperFunctions.setCachedData('page-settings-' + pageID, JSON.stringify(settings));

    }

    return false;

  }

  function getPageSettings() {

    var pageID = $('body').data('i');

    if (pageID && parseInt(pageID, 10)) {

      var settings = pepHelperFunctions.getCachedData('page-settings-' + pageID, 57600000);	//store for 16 hours max

      if ('object' === typeof settings && 'DATA' in settings) {

        if ('string' === typeof settings.DATA && '{' === settings.DATA.substr(0, 1)) {

          try {

            settings.DATA = JSON.parse(settings.DATA);

          } catch (e) {
          }

        }

        return settings.DATA;

      }

    }

    return {};

  }


  window.pepSlideshow = {

    //ELEMENTS
    $ele: $(),
    slides: $(),
    dots: $(),
    dotOverlays: $(),
    captions: $(),

    //TIMERS
    //slideTimer		:	-1,
    transitionTimer: -1,
    dotTimer: -1,
    dotResetTimer: -1,
    renderTimer: -1,
    startTimer: -1,
    videoTimer: -1,
    videoStartTimer: -1,

    //SETTINGS
    index: 0,
    windowIsActive: true,
    slideshowIsActive: false,
    throttleTimeout: 250,
    currentSlide: 0,
    slideshowWidth: 0,
    slideshowHeight: 0,
    slideshowOffsetTop: 0,
    lastSlideStartTime: 0,
    transitionDuration: 925,
    dotResetDuration: 125,
    transitionInProgress: false,
    slidesShown: 0,
    supportTransitions: true,
    supportTouch: false,
    videoStartTimeout: 1000,
    dotDashOffset: 76,

    //FUNCTIONS
    getSlide: function (index) {

      return this.slides.eq(index);

    },
    getCaption: function (index) {

      return this.captions.filter(function () {
        return parseInt($(this).data('index'), 10) === index;
      });

    },
    getDot: function (index) {

      return this.dots.filter(function () {
        return parseInt($(this).data('index'), 10) === index;
      });

    },
    getNextSlideIndex: function (direction) {

      if (typeof direction !== 'number') var direction = 1;

      var newIndex = this.currentSlide + direction;

      if (direction < 0 && newIndex < 0) {

        newIndex = this.slides.length - 1;

      } else if (direction > 0 && newIndex > this.slides.length - 1) {

        newIndex = 0;

      }

      return newIndex;

    },
    calcVideoDims: function (videoData) {

      var newHeight = (videoData.sizing === 'contain')
          ? this.slideshowHeight
          : this.slideshowWidth * videoData.height / videoData.width,
        newTop = (videoData.sizing === 'contain')
          ? 0
          : (newHeight - this.slideshowHeight) * -1 * videoData.focalY / 100,
        newLeft = 0;

      if (newHeight + newTop < this.slideshowHeight) {

        newTop = 0;
        newHeight = this.slideshowHeight;
        this.slideshowWidth = videoData.width * newHeight / videoData.height;
        newLeft = (this.slideshowWidth - allSlideshows[0].$ele.outerWidth()) * -1 * videoData.focalX / 100;

      }

      return {
        width: this.slideshowWidth,
        height: newHeight,
        left: newLeft,
        top: newTop
      };

    },
    checkIfActive: function () {
      //determine if this slideshow is active
      this.slideshowIsActive = !this.$ele.is(':hidden');

      return this.slideshowIsActive;

    },
    renderSlideshow: function () {

      var slideshowOBJ = this;
      var wasActive = this.slideshowIsActive;
      var isActive = this.checkIfActive();
      var $currentSlide = null;

      this.slideshowWidth = this.$ele.outerWidth();
      this.slideshowHeight = this.$ele.outerHeight();
      this.slideshowOffsetTop = this.$ele.offset().top;

      if (this.$ele.data('transform-y')) this.slideshowOffsetTop -= this.$ele.data('transform-y');

      $.each(this.slides.filter('.video'), function () {

        var slideData = $(this).data();

        if (typeof slideData.videoPlayer === 'object') {

          $(this)
            .find('.video-player')
            .css(slideshowOBJ.calcVideoDims(slideData.videoData));

        }

      });

      if (!isActive) {

        //let's see if any other slideshows are active, otherwise indicate to the page that there aren't any
        var foundActiveSlideshow = false;

        for (var i = 0, l = allSlideshows.length; i < l; i++) {

          if (true === allSlideshows[i].slideshowIsActive) {

            foundActiveSlideshow = true;
            break;

          }

        }

        if (true === foundActiveSlideshow) {

          $container
            .removeClass('no-artwork');

        } else {

          $container
            .addClass('no-artwork');

        }

      } else if (wasActive && !isActive) {

        //pause the show since it's not active but it was
        $.each(this.slides.filter('.video'), function () {

          //pause videos
          if ($(this).data('playing') && typeof $(this).data('videoPlayer') === 'object') {

            $(this)
              .data('videoPlayer')
              .pause();

          }

          //stop slides from changing
          clearTimeout(slideshowOBJ.showTimer);

        });

      } else if (!wasActive && isActive) {

        this.changeSlide(this.currentSlide);

        //we know that this slideshow is displaying, so at least one is
        $container
          .removeClass('no-artwork');

      }

    },
    startSlideshow: function () {

      var nextSlide = 0;
      var $slide = null;
      var slideCMSData = {};
      var slideshowOBJ = this;

      if (!this.checkIfActive()) return;

      clearTimeout(this.startTimer);

      this.changeSlide(this.currentSlide);

      //verify the dot thumbs are loaded if not on touch device
      if (!this.supportTouch) {

        $.each(this.dots, function () {

          var $dotOverlay = $(this).children('.dot-overlay');

          if ($dotOverlay.length && !$dotOverlay.children('img').length) {

            $dotOverlay
              .html('<img alt="' + $dotOverlay.data('thumb-alt') + '" src="' + $dotOverlay.data('thumb-src') + '" />')

          }

        });

      }


      /*$slide			=	this.getSlide(this.currentSlide);
				slideCMSData	=	$slide.data('cms-data');

				nextSlide		=	this.currentSlide + 1;*/

    },
    setupSlideshow: function ($slideshowContainer, slideshowIndex) {

      var slideshowOBJ = this;

      this.index = slideshowIndex;
      this.$ele = $slideshowContainer;
      this.slides = this.$ele.children('.content');
      this.dots = this.$ele.children('.thumb-dots').children('.dot');
      this.dotOverlays = this.$ele.children('.thumb-dots').children('.dot-overlay');
      this.captions = this.$ele.children('.slide-caps').children('.caption');

      this.supportTransitions = Modernizr.csstransitions;
      this.supportTouch = Modernizr.touchevents;

      if ($('#container').hasClass('content-page') || $('#container').hasClass('hotel-tower-page')) {

        this.$ele
          .addClass('position-static');

      }

      //check to make sure the show shouldn't be running in 10 seconds
      $(function () {

        slideshowOBJ.startTimer = setTimeout(function () {

          slideshowOBJ.startSlideshow();

        }, 10000);

      });

      $(window)
        .on('resize.artwork' + this.index, function () {

          clearTimeout(slideshowOBJ.renderTimer);
          slideshowOBJ.renderTimer = setTimeout(function () {

            slideshowOBJ.renderSlideshow();

          }, slideshowOBJ.throttleTimeout);

        })
        .on('load.artwork' + this.index, function () {

          clearTimeout(slideshowOBJ.renderTimer);
          slideshowOBJ.renderTimer = setTimeout(function () {

            slideshowOBJ.renderSlideshow();

          }, slideshowOBJ.throttleTimeout);

          slideshowOBJ
            .$ele
            .addClass('loaded');

          if (slideshowOBJ.checkIfActive()) {

            slideshowOBJ.startSlideshow();

          }

        })
        .on('blur.artwork' + this.index, function () {

          slideshowOBJ.windowIsActive = false;

          var $currentSlide = slideshowOBJ.getSlide(slideshowOBJ.currentSlide);

          if ($currentSlide.hasClass('video') && typeof $currentSlide.data('videoPlayer') === 'object') {

            $currentSlide
              .data('videoPlayer')
              .pause();

          }

        })
        .on('focus.artwork' + this.index, function (event) {

          slideshowOBJ.windowIsActive = true;

          var $currentSlide = slideshowOBJ.getSlide(slideshowOBJ.currentSlide);

          if ($currentSlide.hasClass('video') && $currentSlide.data('playing') && typeof $currentSlide.data('videoPlayer') === 'object') {
            //console.log('focus play');
            $currentSlide
              .data('videoPlayer')
              .play();

          }

        });

      this.$ele
        .children('.mobile-nav-arrow')
        .filter('.left')
        .on('click', function (event) {

          event.stopPropagation();
          event.preventDefault();

          slideshowOBJ.changeSlide(slideshowOBJ.getNextSlideIndex(-1));

        })
        .end()
        .filter('.right')
        .on('click', function (event) {

          event.stopPropagation();
          event.preventDefault();

          slideshowOBJ.changeSlide(slideshowOBJ.getNextSlideIndex(1));

        });

      this.dots
        .on('click', function (event) {

          event.preventDefault();
          event.stopPropagation();

          $(this)
            .trigger('mouseleave');

          slideshowOBJ.changeSlide(parseInt($(this).data('index'), 10));

        }).on('mouseleave', function () {

        if (!Modernizr.touchevents) {

          slideshowOBJ.dotTimer = setTimeout(function () {

            slideshowOBJ.dots
              .removeClass('hover');

          }, 75);

        }

      }).on('mouseenter', function () {

        clearTimeout(slideshowOBJ.dotTimer);

        if (!Modernizr.touchevents) {

          //hide all dot overlays, select the one associated with this dot, set the position for the selected overlay, then fade it into view
          slideshowOBJ.dots
            .eq($(this).data('index'))
            .addClass('hover')
            .siblings()
            .removeClass('hover');

        }

      }).each(function () {
        var duration = slideshowOBJ.slides.eq($(this).data('index')).data('cmsData').duration || 5;
        this.style.setProperty('--dot-animation-duration', '' + (duration * 1000) + 'ms');
      });


      //setup art dot
      this.dotOverlays
        .on('click', function (event) {

          $(this)
            .trigger('mouseleave')
            .prev()
            .trigger('click');

        }).on('mouseleave', function () {

        slideshowOBJ.dotTimer = setTimeout(function () {

          slideshowOBJ.showOverlays
            .removeClass('active');

        }, 66);

      }).on('mouseenter', function () {

        clearTimeout(slideshowOBJ.dotTimer);

      });


      this.captions
        .find('.scroll-to-content')
        .on('click', function (event) {

          event.preventDefault();
          event.stopPropagation();

          var headerHeight = (responsive.current === 'ui-mobile')
            ? maxHeaderHeight.mobile
            : maxHeaderHeight.desktop;
          var scrollTo = slideshowOBJ.$ele.offset().top + slideshowOBJ.$ele.outerHeight() - headerHeight;

          $('html, body')
            .animate({scrollTop: scrollTo}, 750, 'easeInOutCubic');

        });


      //preload the first image of the slideshow
      this.loadSlideImage(0);


    },
    loadSlideImage: function (index) {

      var $slide = this.getSlide(index);

      if (!$slide.hasClass('video')) {

        $slide
          .css({
            backgroundImage: "url('" + $slide.data('cms-data').imgSrc + "')"
          });

      } else {

        $slide
          .css({
            backgroundImage: "url('" + $slide.children('.video-player').data('poster') + "')"
          });

      }

    },
    initVideo: function (index) {

      var slideshowOBJ = this;
      var $video = this.getSlide(index).filter('.video');
      var $caption = null;
      var $dot = null;
      //console.group('initVideo');
      //console.log($video.hasClass('initialized'), typeof $video.data('videoPlayer') === 'object');
      if ($video.hasClass('initialized') && typeof $video.data('videoPlayer') === 'object') {

        //if already initialized
        $video
          .data('videoPlayer')
          .setCurrentTime(0);

        if (0 === parseInt($video.data('play-count', 0), 10)) {
          //console.log('init replay');
          $video
            .data('videoPlayer')
            .play();
        }

      } else {

        //initialize a video slide
        var videoData = $video.data('video-data');
        var videoBackup = $video.data('videoBackup') || $video.html();
        //console.log('play count', $video.data('play-count'), !$video.data('play-count'));
        if (!$video.data('play-count')) {
          $video.data('play-count', 0);
        }
        //console.log('play count', $video.data('play-count'));

        $caption = this.getCaption(index);
        $dot = this.getDot(index);

        $caption
          .addClass('active');

        $video
          .data({
            playing: false,
            videoBackup: videoBackup,
            videoPlayer: new Vimeo.Player('artwork-' + this.index + '-video-' + videoData.videoID + '-' + $video.data('index'), {
              id: videoData.videoID,
              //background	:	true,
              loop: false,	//this is handled in code, if left to `true` the `ended` event will not fire
              //autoplay: false,
              controls: false,
              muted: true
            }),
            videoData: videoData,
            lastReportedResolution: ''
          })
          .on('reportResolution', function (event, player) {

            //TODO: need to determine how to check current resolution for the Vimeo player

            /*
							try {

								var resolution	=	player.tech_.hls.masterPlaylistController_.mainSegmentLoader_.playlist_.attributes.RESOLUTION.width + 'x' + player.tech_.hls.masterPlaylistController_.mainSegmentLoader_.playlist_.attributes.RESOLUTION.height + 'px';
								//var vimeoID		=	$(this).data('videoData').videoID;

								if (resolution && $(this).data('lastReportedResolution') !== resolution) {

									pepTracking.event('Video', 'Resolution', resolution);

									$(this)
										.data('lastReportedResolution', resolution);

								}

							} catch (e) {}
							*/
          })
          .find('.video-player')
          .css(this.calcVideoDims(videoData));

        //setup video control button interaction

        $caption
          .find('.video-btn, .volume-btn')
          .filter('.play-btn')
          .off('click.artwork')
          .on('click.artwork', function (event) {

            event.preventDefault();
            event.stopPropagation();

            $(this)
              .addClass('hide')
              .siblings('.pause-btn')
              .removeClass('hide');

            $video
              .data('playing', true);

            if ($video.hasClass('video') && typeof $video.data('videoPlayer') === 'object') {

              clearTimeout($caption.data('loader-timer'));

              $caption
                .addClass('video-playing video-played video-play-manual')
                .removeClass('video-paused video-pause-manual')
                .data('loader-timer', setTimeout(function () {

                  //if ($(event.target).hasClass('vjs-error'))	return;

                  $caption
                    .children('.video-loader')
                    .removeClass('hide');

                }, 5000));
              //console.log('click play');
              $video
                .data('videoPlayer')
                .play();

            }

          })
          .end()
          .filter('.pause-btn')
          .off('click.artwork')
          .on('click.artwork', function (event) {

            event.preventDefault();
            event.stopPropagation();

            $(this)
              .addClass('hide')
              .siblings('.play-btn')
              .removeClass('hide');

            $video
              .data('playing', false);

            if ($video.hasClass('video') && typeof $video.data('videoPlayer') === 'object') {

              $video
                .data('videoPlayer')
                .pause();

            }

            $caption
              .removeClass('video-playing video-play-manual')
              .addClass('video-paused video-pause-manual');

          })
          .end()
          .filter('.volume-btn')
          .removeClass('audio-on')
          .off('click.artwork')
          .on('click.artwork', function (event) {

            event.preventDefault();
            event.stopPropagation();

            if ($(this).hasClass('audio-on')) {

              $video
                .data('videoPlayer')
                .setVolume(0);

              $(this)
                .removeClass('audio-on');

            } else {

              $video
                .data('videoPlayer')
                .setVolume(1);

              $(this)
                .addClass('audio-on');

            }

          });

        //setup Vimeo Player event handlers
        $video
          .data('videoPlayer')
          .on('ended', function () {

            //console.log('video ended');
            $video.data('play-count', parseInt($video.data('play-count'), 10) + 1);
            $video.data('playing', false);

            if (typeof videoData.videoID !== 'undefined') {

              var videoID = '' + videoData.videoID;

              pepTracking.event('Video', 'Ended', videoID);

            }

            $caption
              .removeClass('video-playing')
              .addClass('video-paused video-must-manually-start');
            //console.log('num of slides', slideshowOBJ.slides.length);
            if (slideshowOBJ.slides.length > 1) {

              slideshowOBJ.changeSlide(slideshowOBJ.getNextSlideIndex(1));

            } else {

              //this video is the only slide, show a "reply" button

              //replay
              $video
                .data('videoPlayer')
                .setCurrentTime(0)
              /*.then(function () {

												$video
													.data('videoPlayer')
														.play();

											})*/;


            }

          });


        //setup video event handlers
        $video
          .data('videoPlayer')
          .on('pause', function () {
            //console.log('video paused');
            //$video
            //	.data('playing', false);

            $caption
              .removeClass('video-playing video-play-manual')
              .addClass('video-paused')
              .find('.play-btn, .replay-btn')
              .removeClass('hide')
              .end()
              .find('.pause-btn')
              .addClass('hide');

            $video
              .data('videoPlayer')
              .getCurrentTime()
              .then(function (time) {
                if (time < 0.1) {
                  $caption
                    .addClass('video-must-manually-start');
                }
              });

            clearTimeout($caption.data('loader-timer'));

            //$caption
            //	.children('.video-loader')
            //		.addClass('hide');

            //clearTimeout(slideshowOBJ.showTimer);

          });

        $video
          .data('videoPlayer')
          .on('play', function (a, b, c) {
            //console.log('video play');
            if (!$video.data('play-tracked')) {

              pepTracking.event('Video', 'Started', videoData.videoID.toString());

            }

            $video
              .data('playing', true)
              .data('play-tracked', true);

            $caption
              .removeClass('video-paused video-pause-manual')
              .addClass('video-playing video-played')
              .find('.play-btn, .replay-btn')
              .addClass('hide')
              .end()
              .find('.pause-btn')
              .removeClass('hide');

            clearTimeout($caption.data('loader-timer'));

            $caption
              .children('.video-loader')
              .addClass('hide');

            clearTimeout(slideshowOBJ.showTimer);

          });

        $video
          .data('videoPlayer')
          .on('error', function (data) {

            //TODO: need to figure out how to detect if video is not supported

            //check if the video format is supported
            /*if (parseInt($video.data('videojs').error().code) === 4) {

									//if not then hide video controls, act like nothing is wrong :)
									$video
										.closest('.artwork')
											.addClass('video-not-supported');

								}*/

            pepTracking.event('Video', 'Error', data.name);

          });

        //TODO: only show loading spinner if the play button was pressed ???
        /*$video
						.data('videojs')
							.on('loadstart', function (event) {

								$caption
									.data('loader-timer', setTimeout(function () {

										if (Modernizr.touchevents || $(event.target).hasClass('vjs-error'))	return;

										$artCaption
											.eq(index)
												.find('.video-loader')
													.removeClass('hide');

									}, 5000));

							});*/

        $video
          .data('videoPlayer')
          .on('play', function () {

            clearTimeout($caption.data('loader-timer'));

            $caption
              .children('.video-loader')
              .addClass('hide');

          });

        if ($dot.length) {

          $video
            .data({
              lastRenderDotOffset: -1,
              lastRenderDotText: -1
            })
            .data('videoPlayer')
            .on('timeupdate', function (data) {

              if (typeof data !== 'object') return;

              $video
                .trigger('reportResolution', [this]);

              if ($video.hasClass('active')) {

                //update countdown text and the countdown animation

                if ($video.data('lastRenderDotOffset') !== dashOffset || $video.data('lastRenderDotText') !== countText) {

                  var dashOffset = parseInt(slideshowOBJ.dotDashOffset * data.percent, 10);
                  var countText = parseInt(data.duration - data.seconds, 10);

                  $video
                    .data({
                      lastRenderDotOffset: dashOffset,
                      lastRenderDotText: countText
                    });

                  slideshowOBJ.dots
                    .filter('[data-index=' + $video.data('index') + ']')
                    .find('.text')
                    .text(countText)
                    .end()
                    .find('circle')
                    .css({
                      'stroke-dashoffset': dashOffset + 'px'
                    });

                }

              }

            });

        } else {

          //we still want to report video resolutions even if there are no dots
          $video
            .data('videoPlayer')
            .on('timeupdate', function (data) {

              if (typeof data !== 'object') return;

              $video
                .trigger('reportResolution', [this]);

            });

        }

        if (parseInt($video.data('audio'), 10) === 0) {

          $video
            .data('videoPlayer')
            .setVolume(0);

        }

        $video
          .addClass('initialized');


        if (typeof $video.data('videoPlayer') === 'object') {

          /*$video
							.children('.video-js')
								.css({
									backgroundImage	:	"url('/library/api/video-poster.php?VIDEO_ID=" + videoData.videoID + "')"
								});*/
          //console.log('init');
          $video
            .data('videoPlayer')
            .ready()
            .then(function () {

              var autoplay = parseInt($video.data('video-data').autoplay, 10);
              //console.log('autoplay', autoplay);
              if (autoplay === 1) {// && Modernizr.videoautoplay

                clearTimeout(slideshowOBJ.videoStartTimer);
                //console.log('videoStartTimeout', slideshowOBJ.videoStartTimeout);
                //give the browser a moment to catch up before playing
                slideshowOBJ.videoStartTimer = setTimeout(function () {

                  if (0 === parseInt($video.data('play-count'), 10) && $video.hasClass('active') && slideshowOBJ.windowIsActive === true) {
                    //console.log('ready play');
                    $video
                      .data('videoPlayer')
                      .play()
                      .catch(function (data) {

                        //an error occurred...
                        console.log(data);

                      });

                  }

                }, slideshowOBJ.videoStartTimeout);

              }

            });

          $video
            .find('.video-player')
            .addClass('active');

        }

      }
      //console.groupEnd();
    },
    changeSlide: function (newIndex) {
      //console.log('changeSlide');
      var oldSlideIndex = this.currentSlide;//this.slides.filter('.active').data('index');
      var slideshowOBJ = this;

      this.lastSlideStartTime = new Date().getTime();

      if (this.getSlide(newIndex).hasClass('video')) {
        //console.log('is video slide');
        this.initVideo(newIndex);
      }

      //only run when there is more than one slide
      if (this.slides.length < 2) return false;

      //only run when an existing slide is requested
      if (this.slides.eq(newIndex).length === 0) return false;

      //all transitions must finish before new ones can start
      if (this.transitionInProgress) return false;

      clearTimeout(this.showTimer);
      clearTimeout(this.videoStartTimer);

      this.activateSlide(newIndex);

      if (newIndex !== this.currentSlide) {

        //tasks to run only if we're showing a new slide

        this.deactivateSlide(oldSlideIndex);

        if (newIndex >= this.slides.length.length || newIndex < 0) {
          newIndex = 0;
        }

        this.currentSlide = newIndex;
      }

      if (!this.slides.eq(this.currentSlide).hasClass('video')) {
        this.showTimer = setTimeout(function () {
          slideshowOBJ.changeSlide(slideshowOBJ.getNextSlideIndex(1));
        }, parseInt(this.slides.eq(this.currentSlide).data('cms-data').duration || 10, 10) * 1000 + this.transitionDuration);
      }
    },
    positionThumbs: function (index) {

      //if this slide has a caption
      if (this.getSlide(index).hasClass('has-cap')) {

        //place thumbs above the caption for mobile ui
        this.$ele
          .children('.thumb-dots')
          .addClass('has-cap');

      } else {

        this.$ele
          .children('.thumb-dots')
          .removeClass('has-cap');

      }

    },
    pauseCurrentVideo: function () {

      var $activeVideoSlide = this.slides.filter('.active').filter('.video');

      //pause a video if it's playing in mobile ui
      if ($activeVideoSlide.length && typeof $activeVideoSlide.data('videoPlayer') === 'object') {

        $activeVideoSlide
          .data('videoPlayer')
          .pause();

      }

    },
    playCurrentVideo: function () {

      var $activeVideoSlide = this.slides.filter('.active').filter('.video');

      //play a video if it's paused
      if ($activeVideoSlide.length && $activeVideoSlide.data('playing') && typeof $activeVideoSlide.data('videoPlayer') === 'object') {
        //console.log('playCurrentVideo play');
        $activeVideoSlide
          .data('videoPlayer')
          .play();

      }

    },
    startSlideDot: function (slideIndex) {

      var $slide = this.getSlide(slideIndex);
      var $dot = this.dots.eq(slideIndex);
      var slideshowOBJ = this;

      //video dot animations are handled via video code
      if (this.slides.length < 2) return;

      if ($slide.hasClass('video')) {

        //just activate video dots
        $dot
          .addClass('active');

      } else {

        $dot
          .addClass('reset')
          .children('.text')
          .text('');

        var dotDuration = parseInt($slide.data('cms-data').duration, 10),
          dotStartTime = new Date().getTime(),
          dotTransitionDuration = (2 > this.slidesShown) ? -250 : (750 - this.dotResetDuration),
          dotLastRender = -1,
          dotRunAni = function () {

            var dotTimeLeft = dotDuration - Math.floor((new Date().getTime() - dotStartTime - dotTransitionDuration) / 1000);

            if (dotTimeLeft !== dotLastRender) {

              dotLastRender = dotTimeLeft;

              if (dotTimeLeft < 0) {

                //timer done
                slideshowOBJ.stopSlideDot(slideIndex);

                dotTimeLeft = null;
                dotDuration = null;
                dotStartTime = null;
                dotLastRender = null;
                slideIndex = null;
                $slide = null;
                $dot = null;

              } else if ($dot.data('animation-timer-running')) {

                $dot
                  .removeClass('reset')
                  .children('.text')
                  .text(dotTimeLeft);

                //timer not done
                requestAnimationFrame(dotRunAni);

              }

            } else {

              //not a full second has gone by
              requestAnimationFrame(dotRunAni);

            }

          };

        clearTimeout(this.dotResetTimer);

        this.dotResetTimer = setTimeout(function () {

          $dot
            .data('animation-timer-running', true);

          dotRunAni();

        }, this.dotResetDuration);

        //first slide on page load has no transition so no need to wait for the transition to end before starting the countdown
        //if (isFirstSlideOnPageLoad)	requestAnimationFrame(dotRunAni);

        $dot
          /*.onCSSTransitionEnd(function () {

							if (!isFirstSlideOnPageLoad)	requestAnimationFrame(dotRunAni);

						})*/
          .addClass('active')
          .find('.text')
          .text(dotDuration);

      }

    },
    stopSlideDot: function (slideIndex) {

      var $dot = this.dots.eq(slideIndex);

      $dot
        .data('animation-timer-running', false);

      $dot
        /*.children('.text')
						.onCSSTransitionEnd(function () {

							$(this)
								.text('');

						})
					.end()*/
        .find('circle')
        .css({
          strokeDashoffset: ''
        })
        .end()
        .removeClass('active');


    },
    activateSlide: function (index) {

      var $slide = this.getSlide(index);
      var slideshowOBJ = this;

      this.lastSlideStartTime = new Date().getTime();
      this.slidesShown++;

      this.transitionInProgress = true;

      this.transitionTimer = setTimeout(function () {

        slideshowOBJ.transitionInProgress = false;

      }, this.transitionDuration);

      //activate new slide
      this.loadSlideImage(index);

      $slide
        .addClass('active');

      //activate new caption
      this.captions
        .filter('[data-index=' + index + ']')
        .addClass('active');

      //activate new dot
      this.startSlideDot(index);

      //position thumbs
      this.positionThumbs(index);

      //initialize video if necessary
      if ($slide.hasClass('video') && !$slide.hasClass('initialized')) {

        this.initVideo(index, true);

      }/* else {

					//NOTE: this is now handled in changeSlide()

					//setup timer for next slide
					clearTimeout(this.slideTimer);

					this.slideTimer	= setTimeout(function () {
						console.log('timer', 'slideTimer');
						slideshowOBJ.changeSlide(index);

					}, $slide.data('cms-data').duration * 1000);

				}*/

    },
    deactivateSlide: function (index) {

      var $slide = this.getSlide(index);
      var $caption = this.getCaption(index);

      if ($slide.hasClass('video')) {

        this.dots
          .filter('[data-index=' + index + ']')
          .find('.dot-circle')
          .children()
          .css({
            transitionDuration: '',
            transform: ''
          });

        if (typeof $slide.data('videoPlayer') === 'object') {

          this.videoTimer = setTimeout(function () {

            $slide
              .removeClass('initialized')
              .data('videoPlayer')
              .destroy();

            $slide
              .removeData('videoPlayer');

            $caption
              .removeClass('video-playing video-played video-paused');

            if (typeof $slide.data('video-backup') === 'string') {

              $slide
                .append($slide.data('video-backup'));

            }

          }, 1000);

        }

      }

      //deactivate content
      $slide
        .removeClass('active');

      //deactivate caption
      $caption
        .removeClass('active');

      //update transition duration for dot

      this.stopSlideDot(index);

    }
  };
  var pauseCurrentVideo = function () {

      //pause a video if it's playing in mobile ui
      if ($('html').hasClass('ui-mobile')) {

        for (var i = 0, l = allSlideshows.length; i < l; i++) {

          if (allSlideshows[i].slideshowIsActive && typeof allSlideshows[i].slides.filter('.active.video').data('videoPlayer') === 'object') {

            allSlideshows[i].slides
              .filter('.active.video')
              .data('videoPlayer')
              .pause();

          }

        }

      }

    },
    playCurrentVideo = function () {

      //play a video if it's paused

      for (var i = 0, l = allSlideshows.length; i < l; i++) {

        if (allSlideshows[i].slideshowIsActive && typeof allSlideshows[i].slides.filter('.active.video').data('videoPlayer') === 'object') {
          //console.log('playCurrentVideo (2?) play');
          allSlideshows[i].slides
            .filter('.active.video')
            .data('videoPlayer')
            .play();

        }

      }

    };

  window.allSlideshows = [];

  $(function () {

    $.each($('.artwork'), function (i) {

      var slideshow = $.extend(true, {}, pepSlideshow);

      slideshow.setupSlideshow($(this), i);

      allSlideshows.push(slideshow);

    });

  });


  //globals
  var $container = $('#container');
  var $header = $('#header');
  var $headerSticky = $('#header-sticky');
  var $footer = $('#footer');
  var dims = {
    window: {
      w: $(window).width(),
      h: $(window).height(),
      timer: null
    }
  };
  var cookieData = $('html').data('cookie');
  var responsive = {
    current: 'ui-desktop',
    points: [760, 1240, 1480],
    classes: ['ui-mobile', 'ui-tablet', 'ui-desktop', 'ui-widescreen'],
    orientation: 'landscape',
    timer: null,
    update: function () {

      if (dims.window.w > dims.window.h) {

        $("html").addClass("landscape").removeClass("portrait");
        responsive.orientation = 'landscape';

      } else {

        $("html").addClass("portrait").removeClass("landscape");
        responsive.orientation = 'portrait';

      }

      //determine which responsive-design-break-point should be used

      var found = false;
      for (var i = 0, l = responsive.points.length; i < l; i++) {
        if (dims.window.w <= responsive.points[i]) {
          found = true;
          break;
        }
      }

      //if no match was found then use largest
      if (!found) {
        i = l;
      }

      //overwrite for android (limit to mobile/tablet uis)
      if (isAndroidDevice === true && i > 1) {
        i = 1;
      }

      if (responsive.current !== responsive.classes[i]) {

        clearTimeout(responsive.timer);

        responsive.timer = setTimeout(function () {

          $('html')
            .removeClass('ui-transition');

        }, 250);

        $('html')
          .addClass('ui-transition');

        //var now		=	new Date(),
        //	expire	=	new Date(now.getTime() + (parseInt(cookieData.t, 10) * 10000));

        var currPepUi = document.cookie.replace(/(?:(?:^|.*;\s*)pepui\s*\=\s*([^;]*).*$)|^.*$/, "$1");

        if (cookieData && currPepUi !== responsive.classes[i]) {

          document.cookie = 'pepui=' + responsive.classes[i] + '; expires=' + new Date(new Date().getTime() + 7776000000).toGMTString() + '; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

        }

      }


      $('html')
        .removeClass(responsive.classes.join(' '))
        .addClass(responsive.classes[i]);

      responsive.current = responsive.classes[i];

    }
  };
  var isAndroidDevice = (navigator.userAgent.toLowerCase().indexOf("android") > -1);
  var isOldIE = false;
  var isMinified = !/event/.test(function (event) {
  });

  if (cookieData && cookieData.s === 'secure') cookieData.s = '; secure';

  responsive.update();

  //setup console if it doesn't exist to not cause errors
  if (typeof console !== "object") console = {
    log: function () {
    }
  };

  function getInternetExplorerVersion() {
    var rv = -1; // Return value assumes failure.
    if (navigator.appName == 'Microsoft Internet Explorer') {
      var ua = navigator.userAgent;
      var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
      if (re.exec(ua) != null)
        rv = parseFloat(RegExp.$1);
    }
    return rv;
  }

  //function detectiOSDevice () {

  //	return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  //}

  if (getInternetExplorerVersion() > -1 && getInternetExplorerVersion() < 10) {

    isOldIE = true;

    $('html')
      .addClass('old-ie');

  }

  //if (detectiOSDevice())	$('html').addClass('os-ios');

  function determineBookingPhoneNumber() {

    if (Modernizr.touchevents && ($('html').hasClass('ui-mobile') || $('html').hasClass('ui-tablet'))) {

      return '1-800-821-8568';

    }

    return '1-866-400-0519';

  }


  require('./pepHelperFunctions');


  window.pepConsole = {
    isDev: ('dev.' === location.hostname.substr(0, 4)),
    log: function () {
      if (window.pepConsole.isDev) {
        console.log.apply(window, arguments);
      }
    },
    group: function () {
      if (window.pepConsole.isDev) {
        console.group.apply(window, arguments);
      }
    },
    groupEnd: function () {
      if (window.pepConsole.isDev) {
        console.groupEnd.apply(window, arguments);
      }
    }
  };


  require('./pepDateFunctions');


  //MAIN NAVIGATION CODE//
  var nav = {
      element: $('#nav'),
      timer: null,
      timer2: null,
      clickEvent: 'click',
      links: $('#nav').find('.nav-link')
    },
    touchEffectTimer = null;

  function setupEmailReplacements() {

    $('[data-email-replacement]')
      .filter(function () {

        return $(this).data('setup') !== true;

      })
      .each(function () {

        var data = $(this).data();

        if ($(this).is('a')) {

          this.href = 'mailto: ' + data.user + '@' + data.domain + '.' + data.extension;

        } else {

          $(this).text(data.user + '@' + data.domain + '.' + data.extension);

        }

      });

  }

  setupEmailReplacements();

  nav.element
    .find('.menu-handle')
    .on('click', function (event) {

      event.preventDefault();
      event.stopPropagation();

      $('html')
        .toggleClass('show-nav');

      if ($('html').hasClass('show-nav')) {

        pauseCurrentVideo();

        $(this)
          .data('lastFocusedElement', document.activeElement);

        nav.element.find('.links')
          [0].focus({focusVisible: true});

        if ($(window).scrollTop() < $headerSticky.outerHeight()) {

          $(this)
            .data('rememberScroll', $(window).scrollTop());

          $(window)
            .scrollTop($headerSticky.outerHeight());

        }

      } else {

        playCurrentVideo();

        if (typeof $(this).data('lastFocusedElement') === 'object') {

          $(this)
            .data('lastFocusedElement')
            .focus({focusVisible: true});

          $(this)
            .removeData('lastFocusedElement');

        }

        if (typeof $(this).data('rememberScroll') === 'number') {

          $(window)
            .scrollTop($(this).data('rememberScroll'));

          $(this)
            .removeData('rememberScroll');

        }

      }

    });

  /*$footer
		.find('.menu-handle')
			.on('click', function (event) {

				event.preventDefault();
				event.stopPropagation();

				var $handle	=	$(this);

				$('html').toggleClass('show-nav');

			});*/

  nav.links
    .on('click', function (event) {

      event.stopPropagation();

    });

  $(document)
    .on('click', function () {

      $('html').removeClass('show-nav');

    });

  if (Modernizr.touchevents) {

    function showTouchEffect(ele, event) {

      var $ele = $(ele),
        $newEffect = $('<span class="touch-effect"></span>')
          .css({
            top: ((event.touches[0].clientY - $ele.offset().top + $(window).scrollTop()) / $ele.outerHeight() * 100) + '%',
            left: ((event.touches[0].clientX - $ele.offset().left + $(window).scrollLeft()) / $ele.outerWidth() * 100) + '%'
          });

      $ele
        .append($newEffect);

      setTimeout(function () {

        $newEffect
          .parent()
          .addClass('show-touch-effect');

        setTimeout(function () {

          $newEffect
            .addClass('hide');

          setTimeout(function () {

            $newEffect
              .parent()
              .removeClass('show-touch-effect')
              .end()
              .remove();

          }, 250);

        }, 300);

      }, 50);

    }

    $('a')
      .on('touchstart', function (event) {

        if (event.originalEvent.touches.length === 1 && false === $(this).hasClass('no-touch-effect')) {

          var ele = this,
            evnt = event;

          touchEffectTimer = setTimeout(function () {

            showTouchEffect(ele, evnt.originalEvent);

          }, 50);

        }

      })
      .on('touchmove', function () {

        clearTimeout(touchEffectTimer);

      });

  }


  //page link scroll animation
  var $pageLinkContainers = $('.body-container').filter('.page-links');
  var $pageLinks = $pageLinkContainers.find('.item');
  var pageLinkResizetimer = null;
  var pageLinkCallbacks = [];
  var pageLinkLastUI = '';

  window.resetPageLinks = function ($newPageLinks) {

    if (typeof $newPageLinks === 'object') $pageLinks = $newPageLinks;
    else $pageLinks = $('.page-links').find('.item');

  };

  /**
   *  Resets the
   */
  function resetPageLinksOffset(forceUpdate) {

    //console.group('resetPageLinksOffset()');

    if ('boolean' !== typeof forceUpdate) var forceUpdate = false;

    //console.log('forceUpdate', forceUpdate);

    //we can use the fact that mobile/touch page links will horizontally scroll with the same offset
    if ('ui-mobile' === responsive.current && true === Modernizr.touchevents) {

      $.each($pageLinks.closest('.body-container-scroller'), function () {

        if (true === forceUpdate || !$(this).children('.item').eq(0).data('offsetTop')) {

          $(this)
            .children('.item')
            .data({
              offsetTop: $(this).offset().top,
              height: $(this).outerHeight()
            })
            .each((i, itemNode) => {
              itemNode.dataset.offsetTop = $(this).offset().top;
              itemNode.dataset.height = $(this).outerHeight();
            });

        }

      });

    } else {

      $.each($pageLinks, function (i) {

        if (true === forceUpdate || !$pageLinks.eq(i).data('offsetTop')) {

          $pageLinks
            .eq(i)
            .data({
              offsetTop: $pageLinks.eq(i).offset().top,
              height: $pageLinks.eq(i).outerHeight()
            })
            .each((i, itemNode) => {
              itemNode.dataset.offsetTop = $(this).offset().top;
              itemNode.dataset.height = $(this).outerHeight();
            });

        }

      });

    }

    //console.groupEnd();

  }

  window.recalcPageLinks = function (forceOffsetUpdate) {

    //console.group('recalcPageLinks()');

    if ('boolean' !== forceOffsetUpdate) var forceOffsetUpdate = false;

    //console.log('forceOffsetUpdate', forceOffsetUpdate);

    var nowTime = new Date().getTime();
    var lastStepTime = nowTime;

    //only get offset if it could have changed
    if (true === forceOffsetUpdate || pageLinkLastUI !== responsive.current || 'ui-mobile' !== responsive.current) {

      resetPageLinksOffset(true);

    }

    //nowTime	=	new Date().getTime();
    //console.log('get new offsets', nowTime - lastStepTime);
    //lastStepTime	=	nowTime;

    renderPageLinks();

    //nowTime	=	new Date().getTime();
    //console.log('renderPageLinks()', nowTime - lastStepTime);
    //lastStepTime	=	nowTime;

    lastRenderedScroll = -1;
    pageLinkLastUI = responsive.current;

    //console.groupEnd();

  }

  $(window)
    .on('resize.page-links load.page-links', function (event, callback) {

      if (typeof callback === 'function') pageLinkCallbacks.push(callback);

      clearTimeout(pageLinkResizetimer);

      pageLinkResizetimer = setTimeout(function () {

        //console.group('pageLinkResizetimer');
        //console.log('pageLinkCallbacks.length', pageLinkCallbacks.length);

        var nowTime = new Date().getTime();
        var lastStepTime = nowTime;

        recalcPageLinks();

        //nowTime	=	new Date().getTime();
        //console.log('recalcPageLinks()', nowTime - lastStepTime);
        //lastStepTime	=	nowTime;

        //run all the callbacks that might have stacked up
        for (var i = 0, l = pageLinkCallbacks.length; i < l; i++) {

          pageLinkCallbacks[i].call(this);

        }

        //nowTime	=	new Date().getTime();
        //console.log('pageLinkCallbacks', nowTime - lastStepTime);
        //lastStepTime	=	nowTime;

        //reset callbacks
        pageLinkCallbacks = [];

        //console.groupEnd();

      }, 100);

    });

  $pageLinkContainers
    .find('.page-link-view-more')
    .on('click.plg-expand', function (event) {

      var plgID = $(this).closest('.page-links').data('plg-id');

      event.preventDefault();

      $(this)
        .closest('.page-links')
        .addClass('show-all-items');

      setTimeout(function () {

        recalcPageLinks();

        if (plgID && parseInt(plgID, 10)) {

          savePageSetting('plg-expanded-' + plgID, true);

        }

      }, 33);

    })
    .each(function () {

      var plgID = $(this).closest('.page-links').data('plg-id');

      if (plgID && parseInt(plgID, 10)) {

        var pageSettings = getPageSettings();
        var settingKey = 'plg-expanded-' + plgID;

        if (settingKey in pageSettings && true === pageSettings[settingKey]) {

          $(this)
            .trigger('click.plg-expand');

        }

      }

    });


  //HEADER CODE//
  const headerScrollDist = Math.max(Math.min($(window).height() / 2.5, 600), 250);
  const backToTopScrollDist = $(window).height() * 3;
  let footerBackToTopActive = false;
  const footerScrollDist = parseInt(getComputedStyle(document.body).fontSize, 10) + 44;
  const minFooterOpacity = {
    mobile: 1,
    desktop: 1//0.5
  };
  const maxFooterOpacity = {
    mobile: 1,
    desktop: 1
  };
  let currentScroll = 0;
  lastRenderedScroll = -1;
  let scrollReady = false,
    pageLinkBuffer = 500,
    $backToTop = $footer.find('.above-the-fold').find('.back-to-top');

  window.loadPageLinkImage = function ($pageLink) {

    $pageLink
      .filter(function () {
        return !$(this).data('imageLoaded');
      })
      .data('imageLoaded', true)
      .find('.img')
      .each(function () {

        if (!$(this).data('img-src')) return;

        $(this)
          .css({
            backgroundImage: 'url(\'' + $(this).data('img-src') + '\')'
          });

      });

  }

  function renderPageLinks() {

    //console.group('renderPageLinks()');

    //var nowTime			=	new Date().getTime();
    //var lastStepTime	=	nowTime;


    var scrollCount = 0,
      windowHeight = $(window).height() - 48;

    if ($pageLinks.length === 0) {

      $('html')
        .addClass('scroll-ready');

      scrollReady = true;

    } else {

      resetPageLinksOffset(false);

      //nowTime	=	new Date().getTime();
      //console.log('initialize offsets', nowTime - lastStepTime);
      //lastStepTime	=	nowTime;

      $.each($pageLinks, function (i) {

        //only if the page link is in the viewport and hasn't already been animated into position
        if (!$pageLinks.eq(i).data('scrolled') && $pageLinks.eq(i).data('offsetTop') <= currentScroll + windowHeight && $pageLinks.eq(i).is(':visible')) {

          if ($pageLinks.eq(i).data('offsetTop') + $pageLinks.eq(i).data('height') >= currentScroll) {

            //mark as scrolled
            $pageLinks
              .eq(i)
              .addClass('scrolled delay-' + scrollCount)
              .data('scrolled', true);

            scrollCount++;

            //load image
            loadPageLinkImage($pageLinks.eq(i));

            //preload larger image source if set
            if ($pageLinks.eq(i).data('image-src')) $("<img />")[0].src = $pageLinks.eq(i).data('image-src');

          } else {

            //above the current viewport and not yet shown

            //check if the image should be preloaded
            if ($pageLinks.eq(i).data('offsetTop') + $pageLinks.eq(i).data('height') >= currentScroll - pageLinkBuffer) {

              //load image
              loadPageLinkImage($pageLinks.eq(i));

            }

            $pageLinks
              .eq(i)
              .addClass('above-viewport');

          }

        } else if (!$pageLinks.eq(i).data('scrolled') && $pageLinks.eq(i).data('offsetTop') <= currentScroll + windowHeight + pageLinkBuffer) {

          //ok, not in view but close, preload the image
          //load image
          loadPageLinkImage($pageLinks.eq(i));


        }

      });

      //nowTime	=	new Date().getTime();
      //console.log('render changes', nowTime - lastStepTime);
      //lastStepTime	=	nowTime;

      if (!scrollReady) {

        setTimeout(function () {

          $('html')
            .addClass('scroll-ready');

          scrollReady = true;

        }, 150);

      }

    }

    //console.groupEnd();

  }

  function renderMainNav() {

    //only render when the scroll has changed
    if (lastRenderedScroll !== currentScroll) {

      const headerPercent = (currentScroll / headerScrollDist > 1)
        ? 1
        : currentScroll / headerScrollDist;
      const footerPercent = (currentScroll >= footerScrollDist)
        ? ((currentScroll - footerScrollDist) / headerScrollDist > 1)
          ? 1
          : (currentScroll - footerScrollDist) / headerScrollDist
        : 0;
      const footerOpacity = (responsive.current === 'ui-mobile' || responsive.current === 'ui-tablet')
        ? minFooterOpacity.mobile + (maxFooterOpacity.mobile - minFooterOpacity.mobile) * footerPercent
        : minFooterOpacity.desktop + (maxFooterOpacity.desktop - minFooterOpacity.desktop) * footerPercent;
      const headerHeight = (responsive.current === 'ui-mobile')
        ? maxHeaderHeight.mobile
        : maxHeaderHeight.desktop;
      const backToTopActive = (currentScroll > backToTopScrollDist);

      $header
        .find('.shadow')
        .css({
          opacity: headerPercent
        })
        .end()
        .find('.nav-tab')
        .find('image')
        .css({
          opacity: headerPercent
        })
        .end();

      if (currentScroll + dims.window.h - footerScrollDist >= containerHeight + containerOffset) {

        const distanceThrough = containerHeight + containerOffset - (currentScroll + dims.window.h) + footerScrollDist;
        const percentThrough = Math.abs(distanceThrough / (footerHeight - footerScrollDist));

        $footer
          .addClass('above-the-fold-static footer-shown')
          .find('.above-the-fold')
          .children('.shadow')
          .css({
            opacity: 1 - percentThrough
          });

        $('html')
          .removeClass('footer-showing');

      } else if (currentScroll >= footerScrollDist) {

        $footer
          .removeClass('above-the-fold-static')
          .find('.above-the-fold')
          .css({
            transform: 'translateY(0px)',
            opacity: footerOpacity
          })
          .children('.shadow')
          .css({
            opacity: footerPercent
          });

        $('html')
          .addClass('footer-showing');

        if (backToTopActive && !footerBackToTopActive) {

          footerBackToTopActive = true;

          $backToTop
            .addClass('active');

        } else if (!backToTopActive && footerBackToTopActive) {

          footerBackToTopActive = false;

          $backToTop
            .removeClass('active');

        }

      } else {

        $footer
          .removeClass('above-the-fold-static')
          .find('.above-the-fold')
          .css({
            transform: 'translateY(' + (footerScrollDist - currentScroll) + 'px)',
            opacity: footerOpacity
          })
          .children('.shadow')
          .css({
            opacity: footerPercent
          });

        $('html')
          .removeClass('footer-showing');

      }


      //check if any slideshows need to be paused
      $.each(allSlideshows, function (i) {

        var videoOBJ = (allSlideshows[i].slideshowIsActive) ? allSlideshows[i].slides.filter('.active.video.initialized').data('videoPlayer') : undefined;

        //if the artwork is out of viewport, do nothing (but pause videos)
        if (allSlideshows[i].slideshowOffsetTop + allSlideshows[i].slideshowHeight - headerHeight <= currentScroll) {

          if (typeof videoOBJ === 'object') {

            videoOBJ
              .getPaused()
              .then(function (paused) {

                if (!paused) {

                  videoOBJ
                    .pause();

                }

              });
          }

        } else if (allSlideshows[i].slideshowIsActive) {

          if (typeof videoOBJ === 'object' && allSlideshows[i].slides.eq(allSlideshows[i].currentSlide).data('playing') && allSlideshows[i].getCaption(allSlideshows[i].currentSlide).hasClass('video-played') && !allSlideshows[i].getCaption(allSlideshows[i].currentSlide).hasClass('video-pause-manual')) {
            //console.log('scroll play');
            videoOBJ
              .getPaused()
              .then(function (paused) {

                if (paused) {

                  videoOBJ
                    .play();

                }

              });
          }

        }

      });

      //check if any page link items need to be animated
      renderPageLinks();

      //update last rendered scroll position
      lastRenderedScroll = currentScroll;

    }

    requestAnimationFrame(renderMainNav);

  }

  requestAnimationFrame(renderMainNav);

  if ($("html").hasClass("hashchange")) {

    $(window).on('scroll.header', function (event, userTriggered) {

      if (typeof userTriggered !== 'boolean' || userTriggered === true) userHasScrolled = true;

      currentScroll = $(this).scrollTop();

      clearTimeout(touchEffectTimer);

    }).trigger('scroll.header', [false]);

  }

  $(function () {

    renderPageLinks();

  });

  //$(window)
  //	.on('resize.pagelinks load.pagelinks', function () {

  //		renderPageLinks();

  //	});

  //setInterval(renderPageLinks, 5000);

  $backToTop
    .on('click', function (event) {

      event.preventDefault();

      $('html, body')
        .stop(true)
        .animate({
          scrollTop: 0
        }, Math.min(Math.max(350, $(window).scrollTop() / 10), 2000), 'easeInOutCubic');

    });


  //DIALOG CODE
  var loaderClickTimer = null;
  var loaderDisableClickClose = false;

  window.showLoader = function (showLoadingSpinner) {

    //DEBUGGING
    //console.log('showLoader', 'showLoadingSpinner', showLoadingSpinner);
    //

    if ('boolean' !== typeof showLoadingSpinner) showLoadingSpinner = true;

    loaderDisableClickClose = true;

    loaderClickTimer = setTimeout(function () {
      loaderDisableClickClose = false;
    }, 350);

    var classes = ['show-overlay'];

    if (true === showLoadingSpinner) classes.push('show-loading-spinner');

    $('html')
      .addClass(classes.join(' '));

  };

  window.hideLoader = function (closeDialog, forceHide) {

    //DEBUGGING
    //console.log('hideLoader', 'closeDialog', closeDialog, 'forceHide', forceHide);
    //

    if ('boolean' !== typeof forceHide) var forceHide = false;
    if ('boolean' !== typeof closeDialog) var closeDialog = true;

    if (true === loaderDisableClickClose && false === forceHide) return;

    loaderDisableClickClose = false;

    $('html')
      .removeClass('show-overlay show-loading-spinner clear-overlay');

    if (true === closeDialog) {

      $('.dialog')
        .trigger('close', [true]);

    }

  };

  $(document)
    .on('click', function () {

      hideLoader(true, false);

    })
    .on('keydown', function (event) {

      if (event.which === 27) hideLoader(true, false);

    });

  $('#overlay').on('click', (event) => {
    event.stopPropagation();
    hideLoader(true, false);
  });

  $(document)
    .on('click', 'a.ajax-link', function (event) {
      const $link = $(this);
      if (typeof $link.data('query') !== 'string' && typeof $link.data('callback') !== 'string') return;

      event.preventDefault();
      event.stopPropagation();

      window.showOverlayDialog($link.data(), this);
    });

  require('./helpers/ExternalLinkWarning');


  function updateHeaderReservationWidgetBAR() {

    var selectedDates = $header.find('.pepvalidate-v3').filter('.reservations').find('.check-in-out').find('input').data('datepicker').selectedDates;

    if (selectedDates.length === 2) {

      var checkInRegMatch = /(20[0-9]{2})\-([0-9]{1,2})\-([0-9]{1,2})/.exec(selectedDates[0].getFullYear() + '-' + (selectedDates[0].getMonth() + 1) + '-' + selectedDates[0].getDate());
      var checkOutRegMatch = /(20[0-9]{2})\-([0-9]{1,2})\-([0-9]{1,2})/.exec(selectedDates[1].getFullYear() + '-' + (selectedDates[1].getMonth() + 1) + '-' + selectedDates[1].getDate());

      if (!!checkInRegMatch && !!checkOutRegMatch) {

        //verify correct format for months
        if (checkInRegMatch[2].length < 2) checkInRegMatch[2] = '0' + checkInRegMatch[2];
        if (checkOutRegMatch[2].length < 2) checkOutRegMatch[2] = '0' + checkOutRegMatch[2];

        //verify correct format for days
        if (checkInRegMatch[3].length < 2) checkInRegMatch[3] = '0' + checkInRegMatch[3];
        if (checkOutRegMatch[3].length < 2) checkOutRegMatch[3] = '0' + checkOutRegMatch[3];

        var checkInDateStr = checkInRegMatch[1] + '-' + checkInRegMatch[2] + '-' + checkInRegMatch[3];
        var checkOutDateStr = checkOutRegMatch[1] + '-' + checkOutRegMatch[2] + '-' + checkOutRegMatch[3];

        if ($header.find('.nav-tab').filter('.reservation').data('dataLastCheckIn') !== checkInDateStr || $header.find('.nav-tab').filter('.reservation').data('dataLastCheckOut') !== checkOutDateStr) {

          $header.find('.nav-tab').filter('.reservation').data('dataLastCheckIn', checkInDateStr);
          $header.find('.nav-tab').filter('.reservation').data('dataLastCheckOut', checkOutDateStr);

          $header
            .find('.nav-tab')
            .filter('.reservation')
            .data('dataLoaded', true);

          clearTimeout($header.find('.nav-tab').filter('.reservation').data('dataTimeout'));

          $header
            .find('.nav-tab')
            .filter('.reservation')
            .data('dataTimeout', setTimeout(function () {

              $header
                .find('.pepvalidate-v3')
                .filter('.reservations')
                .find('.tower')
                .find('.rate')
                .text('Loading...');

            }, 5000));

          $.ajax({
            url: '/library/api/room-rates.php',
            type: 'post',
            dataType: 'json',
            data: {
              ACTION: 'GET_TOWER_BAR',
              CHECKIN_DATE: checkInDateStr,
              CHECKOUT_DATE: checkOutDateStr
            },
            success: function (response) {

              if (response.STATUS === 'SUCCESS') {

                clearTimeout($header.find('.nav-tab').filter('.reservation').data('dataTimeout'));

                var blacklist = [];

                for (var cls in response.DATA) {

                  blacklist.push(cls);

                  $header
                    .find('.pepvalidate-v3')
                    .filter('.reservations')
                    .find('.tower')
                    .filter('.' + cls)
                    .find('.rate')
                    .text('Rates from $' + response.DATA[cls] + ' per night!');

                }

                //if not included in response, there isn't any availability
                $header
                  .find('.pepvalidate-v3')
                  .filter('.reservations')
                  .find('.tower')
                  .not('.' + blacklist.join(', .'))
                  .find('.rate')
                  .text('Sold Out');

              }

            }
          });

        }

      }

    }

  }

  $headerSticky
    .find('.search')
    .on('click', function (event) {

      event.preventDefault();
      event.stopPropagation();

      if (!$(this).hasClass('active')) {

        $(this)
          .find('.input')
          .onCSSTransitionEnd(function () {

            $headerSticky
              .find('.search')
              .find('input')
              [0].focus({focusVisible: true});

          })
          .end()
          .addClass('active');

      } else if ($(this).find('input').val() !== '') {

        $(this)
          .find('input')
          .trigger('send');

      } else {

        $(this)
          .removeClass('active');

      }

    })
    .find('.input, input')
    .on('click', function (event) {

      event.stopPropagation();

      if ($(this).hasClass('input')) {

        $(this)
          .find('input')
          [0].focus({focusVisible: true});

      }

    })
    .filter('input')
    .on('send', function () {

      if ($.trim($(this).val()) !== '') window.location.href = '/search/?s=' + encodeURIComponent($.trim($(this).val()));
      //if ($.trim($(this).val()) !== '')	window.location.href	=	$header.find('.search')[0].href + '?s=' + encodeURIComponent($.trim($(this).val())) + '&CSRF_TOKEN=' + encodeURIComponent($(this).closest('.search').find('[name=CSRF_TOKEN]').val()) + '&' + $(this).closest('.search').find('[name=CSRF_TOKEN]').next('input').attr('name') + '=' + encodeURIComponent($(this).closest('.search').find('[name=CSRF_TOKEN]').next('input').val());

    })
    .on('keydown', function (event) {

      if (event.which === 13) $(this).trigger('send');

    });

  $header
    .find('.pepvalidate-v3')
    .on('click', function (event) {

      event.stopPropagation();

    });

  $header
    .find('.nav-tab')
    .data({
      timer: null,
      clickOK: true,
      clickTimeout: 500,
      dataLoaded: false,
      dataTimeout: null,
      dataLastCheckIn: '',
      dataLastCheckOut: ''
    })
    .on('click', function (event) {

      event.stopPropagation();

    })
    .filter('.reservation')
    .on('click', function (event, onlyOpen) {

      event.preventDefault();

      if (typeof onlyOpen !== 'boolean') var onlyOpen = false;

      if (onlyOpen && $header.find('.pepvalidate-v3').filter('.reservations').hasClass('active')) return;

      var $btn = $(this);

      if (!$btn.data('clickOK')) return;

      $header
        .find('.pepvalidate-v3')
        .filter('.reservations')
        .toggleClass('active')
        .end()
        .filter('.passport')
        .removeClass('active');

      if ($header.find('.pepvalidate-v3').filter('.reservations').hasClass('active')) {

        //track button click
        pepTracking.event('Reservations Header', 'Open', window.location.pathname, 0, false);

        //pause a video if it's playing in mobile ui
        pauseCurrentVideo();

      } else {

        //track button click
        pepTracking.event('Reservations Header', 'Close', window.location.pathname, 0, false);

        //play a video if it's paused
        playCurrentVideo();

      }

      $btn
        .data({
          clickOK: false,
          timer: setTimeout(function () {

            $btn
              .data('clickOK', true);

          }, $btn.data('clickTimeout'))
        });


      //load tower rate data
      if ($btn.data('dataLoaded') !== true) {

        updateHeaderReservationWidgetBAR();

      }

    })
    .end()
    .filter('.passport-club')
    .on('click', function (event, onlyOpen) {

      var $btn = $(this);

      if (!$btn.data('clickOK')) {

        event.preventDefault();

        return;

      }

      //check for logout
      if ($btn.find('.text').text().indexOf('SEE') > -1) {

        return;

      } else if ($btn.hasClass('logout')) {

        event.preventDefault();

        var newURL = window.location.pathname + window.location.search;

        if (newURL.indexOf('?') > -1) newURL += '&logout=true';
        else newURL += '?logout=true';

        window.location.href = newURL;

        return false;

      }

      event.preventDefault();

      if (typeof onlyOpen !== 'boolean') var onlyOpen = false;

      if (onlyOpen && $header.find('.pepvalidate-v3').filter('.passport').hasClass('active')) return;

      $header
        .find('.pepvalidate-v3')
        .filter('.passport')
        .toggleClass('active')
        .end()
        .filter('.reservations')
        .removeClass('active');

      if ($header.find('.pepvalidate-v3').filter('.passport').hasClass('active')) {

        //track button click
        pepTracking.event('Players Club Header', 'Open', window.location.pathname, 0, false);

        //pause a video if it's playing in mobile ui
        pauseCurrentVideo();

      } else {

        //track button click
        pepTracking.event('Players Club Header', 'Close', window.location.pathname, 0, false);

        //play a video if it's paused
        playCurrentVideo();

      }

      //if ($header.find('.pepvalidate-v3').filter('.passport').hasClass('active'))	setTimeout(function () {$header.find('.pepvalidate-v3').filter('.passport').find('[name=username]')[0].focus({focusVisible: true}).select()}, 250);

      $btn
        .data({
          clickOK: false,
          timer: setTimeout(function () {

            $btn
              .data('clickOK', true);

          }, $btn.data('clickTimeout'))
        });

    });

  $(function () {

    //Check if the user can connect to SUGAR
    window.sslNotify = {
      cookie: '',
      data: {},
      show: false,
      func: function () {

        $.ajax({
          url: 'https://reserve1.peppermillcas.com:4323/misc/check-secure-connection.js',
          dataType: 'jsonp',
          jsonpCallback: 'cscCallback',
          timeout: 15000,
          success: function () {

            //only check once an hour if a connection was successfully made
            sslNotify.show = false;

            if (cookieData) document.cookie = 'ssl-notify={"ok":"yes","time":' + new Date().getTime() + '}; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

          },
          error: function (a, b, c) {

            sslNotify.show = true;

            if (cookieData) document.cookie = 'ssl-notify={"ok":"no","time":' + new Date().getTime() + '}; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

          }
        });

      }
    };
    sslNotify.cookie = document.cookie.replace(/(?:(?:^|.*;\s*)ssl-notify\s*\=\s*([^;]*).*$)|^.*$/, "$1") || '{"ok":"no","time":0}';
    sslNotify.data = $.parseJSON(sslNotify.cookie);

    //backwards compatability
    if (typeof sslNotify.data === 'number') {

      sslNotify.data = {
        ok: 'no',
        time: sslNotify.data
      };

    }

    if (sslNotify.data.time === 0) {

      //object was just initialized, no check has occured
      sslNotify.func();

    } else if (sslNotify.data.ok === 'yes' && sslNotify.data.time < (new Date().getTime() - 3600000)) {

      //object was created from cookie but the last check was over an hour ago
      sslNotify.func();

    } else if (sslNotify.data.ok === 'no') {

      sslNotify.show = true;

      if (sslNotify.data.time < (new Date().getTime() - 100000)) {

        //object was created from cookie and the last check failed but it was checked over five minutes ago
        sslNotify.func();

      }

    }

  });


  //do all window.resize code
  var resizeTimer = null,
    iresizetimer = null,
    loadFired = false;

  var headerHeight = ($header.length) ? $header.height() : 0;
  var containerHeight = ($container.length) ? $container.height() : $('body').height();
  var containerOffset = ($container.length) ? $container.offset().top : 0;
  var footerHeight = ($container.length) ? $footer.height() : 0;

  $(window).on("resize.all load.all orientationchange.all", function (event, delay) {
    if (typeof delay !== 'integer') {
      if (event.type.toLowerCase() === 'load') {
        var delay = 0;
        loadFired = true;
      } else {
        var delay = 100;
      }
    }

    function theFunc() {

      //GLOBAL
      //update saved viewport dimensions
      dims.window.w = $(window).width();
      dims.window.h = $(window).height();

      headerHeight = ($header.length) ? $header.height() : 0;
      containerHeight = ($container.length) ? $container.height() : $('body').height();
      containerOffset = ($container.length) ? $container.offset().top : 0;
      footerHeight = ($container.length) ? $footer.height() : 0;

      responsive.update();

    }

    clearTimeout(resizeTimer);
    if (delay === 0) {
      theFunc();
    } else {
      resizeTimer = setTimeout(theFunc, delay);
    }
  }).trigger("resize.all", 0);


  //Text Size Code
  $("#container").on("click", ".text-size-btn", function (event) {

    event.preventDefault();

    //var now			=	new Date(),
    //	expire		=	new Date(now.getTime() + (parseInt(cookieData.timeout, 10) * 10000));

    if (!$("html").hasClass("text-increase")) {
      //go big
      $("html").addClass("text-increase");

      if (cookieData) document.cookie = 'text-size=text-increase; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

      pepTracking.event('Text Size', 'Increase', window.location.pathname, 0, false);
    } else {
      //go normal
      $("html").removeClass("text-increase");

      if (cookieData) document.cookie = 'text-size=; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

      pepTracking.event('Text Size', 'Normal', window.location.pathname, 0, false);
    }

    //force redraw
    $(window).trigger("resize");

  });


  //setup GA tracking code
  window.pepTracking = {
    page: function (customPage) {
      if (typeof gtag === 'undefined') return;

      if (typeof customPage === 'string' && customPage !== '') {
        gtag('event', 'page_view', {
          page: customPage
        });
      }
    },
    event: function (category, action, extra, value, ni) {

      if (typeof gtag === 'undefined') return;

      if (typeof category !== 'string') category = 'N/A';

      if (typeof action !== 'string') action = 'N/A';

      if (typeof extra !== 'string') extra = 'N/A';

      if (typeof value !== 'number') value = 0;

      if (typeof ni !== 'boolean') ni = false;

      gtag('event', action, {
        hitType: 'event',
        event_category: category,
        event_action: action,
        event_label: extra,
        nonInteraction: ni,
        transport: 'beacon',
        value: value
      });

    },
    getGALinkerParam: function () {
      //get GA (UA) tracker param//get GA tracker param
      var output = '',
        anchorEle = $('<a href="/"></a>')[0];

      if (typeof anchorEle === 'object' && typeof ga !== 'undefined') {

        ga('linker:decorate', anchorEle);

        if (typeof anchorEle.search === 'string') {

          if (anchorEle.search.replace('?', '').substr(0, 4) === '_ga=') {

            output = anchorEle.search.replace('?', '').substr(4);

          }

        }

      }

      return output;
    },
    getGA4LinkerParam: function () {
      //get GA4 tracker param

      const formNode = document.createElement('FORM');
      formNode.action = (window.pepConsole.isDev) ? 'https://devbooking.peppermillreno.com/' : 'https://booking.peppermillreno.com/';
      formNode.style.opacity = '0';
      formNode.addEventListener('submit', (event) => {
        event.preventDefault();
      });

      const buttonNode = document.createElement('BUTTON');
      buttonNode.type = 'submit';
      formNode.append(buttonNode);

      document.body.append(formNode);

      buttonNode.click();

      const _glNode = formNode.querySelector('input[name="_gl"]');

      let output = '';
      if (_glNode) {
        output = _glNode.value;
      }

      formNode.remove();

      return output;
    }
  };

  /*$("#container").on("click", '.track-click', function () {
		pepTracking.page($(this).attr('href'));
	});*/

  //find links that go to the /choose-a-room/ or /offers/ pages and add GA linker data to them
  $.each($('.body-container').find('a'), function () {

    if (this.href.substr(0, 37) === 'https://www.peppermillreno.com/offers' || this.href.substr(0, 44) === 'https://www.peppermillreno.com/choose-a-room') {

      if (typeof ga !== 'undefined') ga('linker:decorate', this);

    }

  });


  //SETUP NOTIFICATIONS
  const $notifications = $('#notifications');
  window.pepNotify = {
    ele: $notifications,
    viewport: $notifications.children('.viewport'),
    show: function (duration, msg, type, actionText, actionLink, callback, forceClose) {
      if (typeof forceClose !== 'boolean') {
        forceClose = false;
      }

      //make sure this notification doesn't already exist
      const $match = pepNotify.viewport.children('.notification').filter(function () {

        const data = $(this).data();

        return (data.duration === duration && data.msg === msg && data.type === type && data.actionText === actionText && data.actionLink === actionLink);

      });

      if ($match.length) {

        if ($match.find('.count').length === 0) {

          $match.append('<span class="count">2</span>');

          setTimeout(function () {

            $match
              .find('.count')
              .onCSSAnimationEnd(function () {
                $(this).removeClass('bounce');
              })
              .addClass('show bounce');

          }, 50);
        } else {
          $match
            .find('.count')
            .text(parseInt($match.find('.count').text(), 10) + 1)
            .onCSSAnimationEnd(function () {

              $(this).removeClass('bounce');

            }).addClass('bounce');

        }

        pepNotify.reset($match);

        return;
      }

      const $ele = $(pepNotify.buildHTML(msg, type, actionText, actionLink, callback))
        .data({
          duration: duration,
          msg: msg,
          type: type,
          actionText: actionText,
          actionLink: actionLink,
          callback: callback,
          forceClose: forceClose
        });

      $ele
        .on('mouseenter', function () {

          if ($ele.hasClass('closing')) return;

          if (!$ele.data('forceClose')) clearTimeout($ele.data('timer'));

          $ele.addClass('hover');

        })
        .on('mouseleave', function () {

          pepNotify.activate($ele);

          $ele.removeClass('hover');

        })
        .find('.action')
        .on('click', function (event) {

          if ($(this).hasClass('close') || $(this).attr('href') === '#') event.preventDefault();

          $ele.removeClass('hover').addClass('closing');

          pepNotify.close($ele, true);

        });

      pepNotify.viewport.append($ele);

      if (pepNotify.viewport.children('.notification').filter('.active').length === 0) {

        setTimeout(function () {

          pepNotify.activate($ele);

        }, 50);

      }

    },
    close: function ($ele, closeFromClick) {

      if (typeof closeFromClick !== 'boolean') {
        closeFromClick = false;
      }

      pepNotify.ele.onCSSTransitionEnd(function () {

        if (!$ele.data('forceClose') && $ele.hasClass('hover') && !$ele.hasClass('closing')) return;

        if (typeof $ele.data('callback') === 'function' && (closeFromClick || $ele.data('forceClose'))) {
          $ele.data('callback')();
        }

        $ele.remove();

        pepNotify.rotate();

      }).removeClass('show');

      $('html').removeClass('show-notify');

    },
    reset: function ($ele) {

      clearTimeout($ele.data('timer'));

      $ele.data('timer', setTimeout(function () {

        pepNotify.close($ele);

      }, $ele.data('duration')));

    },
    activate: function ($ele) {

      if ($ele.hasClass('closing')) return;

      pepNotify.ele.addClass('show');

      $('html').addClass('show-notify');

      $ele.addClass('active').data('timer', setTimeout(function () {

        pepNotify.close($ele);

      }, $ele.data('duration')));

    },
    rotate: function () {
      const $notifications = pepNotify.viewport.children('.notification');

      if ($notifications.length > 0 && $notifications.filter('.active').length === 0) {
        pepNotify.activate($notifications.eq(0));
      }
    },
    buildHTML: function (msg, type, actionText, actionLink, actionCallback) {
      let html = '<div class="notification" role="status"><table class="no-zebra"><tbody><tr><td class="content">';

      if (typeof type === 'string') {
        html += '<span class="material-icons">' + type + '</span> ';
      }

      html += msg + '</td><td class="action-cell">';

      if (typeof actionText === 'string' && (typeof actionLink === 'string' || typeof actionCallback === 'function')) {
        if (typeof actionLink !== 'string') {
          actionLink = '#';
        }

        html += '<a class="action" href="' + actionLink + '">' + actionText + '</span>';
      } else {
        html += '<a class="action close" href="#">HIDE</span>';
      }

      html += '</td></tr></table></div>';

      return html;

    }
  };


  /*PRELOAD IMAGES*/
  $(window).on("load", function () {

    var preloadImages = $('#image-preload').data('images') || [];

    for (var i = 0, l = preloadImages.length; i < l; i++) {

      $("<img />")[0].src = preloadImages[i];

    }

  });


  //Append GA to URL for /manage-reservation
  $(function () {
    const target = $("a.btn[href^='/manage-reservation']");
    target.click(function () {
      const regEx = new RegExp(/[&?]_ga=.+/);
      const gaParam = pepTracking.getGALinkerParam();
      const ga4Param = pepTracking.getGA4LinkerParam();
      const oldHref = $(this).attr("href");
      if (!regEx.test(oldHref)) {
        const gaQs = (oldHref.indexOf("?") > -1) ? "&" : "?";
        target.attr("href", oldHref + gaQs + '_ga=' + gaParam + '&_gl=' + ga4Param);
      }
    })
  });

  //SETUP HEADER PASSPORT LOGIN CALLBACKS
  $(function () {

    if ('pepvalidateRegisterCallback' in window) {

      window.pepvalidateRegisterCallback(
        'PASSPORT-HEADER-LOGIN-SUCCESS',
        function (redirect, rememberMe) {

          var rm = (rememberMe)
            ? 'Remember Me'
            : 'Standard';

          pepTracking.event('Players Club', 'Login Success', rm, 0, true);

          setTimeout(function () {

            window.location.href = redirect;

          }, 50);

        }
      );

      window.pepvalidateRegisterCallback(
        'PASSPORT-HEADER-LOGIN-ERROR',
        function (msg) {

          pepTracking.event('Players Club', 'Login Failure', msg, 0, true);

          pepNotify.show(10000, msg, 'error');

          $(this)
            .removeClass('loading');

        }
      );

      window.pepvalidateRegisterCallback(
        'PASSPORT-HEADER-LOGOUT-SUCCESS',
        function () {

          pepNotify.show(10000, 'You are now logged out.', 'done');

        }
      );

      //also setup a generic callback for showing a pepNotify notification
      window.pepvalidateRegisterCallback(
        'GENERIC-FORM-NOTIFICATION',
        function (msg, icon, duration) {

          if (typeof icon !== 'string') icon = '';
          if (typeof duration === 'undefined') duration = 10000;

          pepNotify.show(duration, msg, icon);

          $(this)
            .removeClass('loading');

        }
      );

    }

  });


  //SETUP GENERIC FORMS
  $(function () {

    setTimeout(function () {

      if ('pepvalidateInitForm' in window) {

        $.each($container.find('.pepvalidate-v3'), window.pepvalidateInitForm);
        $.each($footer.find('.pepvalidate-v3'), window.pepvalidateInitForm);

      }

    }, 50);

  });


  //Check if Sprites Have Been Loaded
  if ('localStorage' in window) {

    $(function () {

      //first load from cookie
      var spriteCookie = document.cookie.replace(/(?:(?:^|.*;\s*)pepsprites\s*\=\s*([^;]*).*$)|^.*$/, "$1"),
        spritesLoaded = [],
        cookieSprites = (spriteCookie === '')
          ? []
          : (spriteCookie.indexOf(',') > -1)
            ? spriteCookie.split(',')
            : [spriteCookie];

      function saveLoadedSprites() {

        var $sprites = $('body').children('.system-sprite'),
          expiresDate = new Date();

        spritesLoaded = [];

        //expire in 15 minutes
        expiresDate.setTime(new Date().getTime() + 900000);

        $.each($sprites, function (i) {

          try {

            var spriteHTML = $('<div />').append($sprites.eq(i).clone()).html();

            localStorage.setItem('sprite-' + $sprites.eq(i).attr('id'), spriteHTML);

            spritesLoaded.push($sprites.eq(i).attr('id'));

          } catch (e) {
          }

        });

        if (cookieData) document.cookie = 'pepsprites=' + spritesLoaded.join(',') + '; expires=' + expiresDate.toGMTString() + '; path=' + cookieData.b + cookieData.s + '; ' + cookieData.h;

      }

      //first add the sprites from localstorage that we have
      if (cookieSprites.length) {

        for (var i = 0, l = cookieSprites.length; i < l; i++) {

          try {

            var spriteHTML = localStorage.getItem('sprite-' + cookieSprites[i]);

            if (typeof spriteHTML === 'string' && spriteHTML.substr(0, 5) === '<svg ' && spriteHTML.length > 0 && $('#' + cookieSprites[i]).length === 0) {

              $('body')
                .append(spriteHTML);

              spritesLoaded.push(cookieSprites[i]);

            }

          } catch (e) {
          }

        }

      } else {

        //we don't have any sprites saved but let's see if the main sprite exists
        //	if not then let's search localStorage for sprites...
        if (0 === $('#main-sprite-svg').length) {

          for (var key in localStorage) {

            if ('sprite-' === key.substr(0, 7)) {

              try {

                var spriteHTML = localStorage.getItem(key);

                if (typeof spriteHTML === 'string' && spriteHTML.substr(0, 5) === '<svg ' && spriteHTML.length > 0 && $('#' + cookieSprites[i]).length === 0) {

                  $('body')
                    .append(spriteHTML);

                  spritesLoaded.push(key);

                }

              } catch (e) {
              }

            }

          }

        }

      }

      //second, look for what spries exist and save them in localstorage
      saveLoadedSprites();

      //check the difference between the cookieSprites array and the spritesLoaded array, to load any necessary sprites over AJAX
      for (var i = 0, l = cookieSprites.length; i < l; i++) {

        if (spritesLoaded.indexOf(cookieSprites[i]) === -1) {

          (function (inner_i) {

            //this cookie sprite could not be loaded from localStorage and it was not included in the page output
            $.ajax({
              url: '/library/html/templates/' + cookieSprites[inner_i] + '.svg',
              type: 'get',
              dataType: 'html',
              success: function (response) {

                if (typeof response === 'string' && response.substr(0, 5) === '<svg ' && $('#' + cookieSprites[inner_i]).length === 0) {

                  $('body')
                    .append(response);

                  saveLoadedSprites();

                }

              }
            });

          })(i);

        }

      }

    });

  }


  //handle footer award logo animation
  const $footerAwards = $footer.find('.award-logos li').children();
  if ($footerAwards.length > 1) {
    setInterval(function () {
      const current = $footerAwards.not('.hide').index();
      const next = (current + 1 >= $footerAwards.length)
        ? 0
        : current + 1;

      $footerAwards
        .eq(current)
        .addClass('hide')
        .attr('aria-hidden', 'true')
        .children()
        .attr('tabindex', '-1')
        .end()
        .end()
        .eq(next)
        .removeClass('hide')
        .removeAttr('aria-hidden')
        .children()
        .removeAttr('tabindex');
    }, 5000);
  }


  //SETUP TABLE INTERACTIONS
  $('.table-pagination')
    .find('.material-icons')
    .filter('.disabled')
    .on('click', function (event) {

      event.preventDefault();

    })
    .end()
    .end()
    .find('select[name=ROWS_PER_PAGE]')
    .on('change', function () {

      if ($(this).val() === '') return;

      var linkData = $(this).closest('.table-pagination').data();

      window.location = window.location.pathname + '?SORT_COL=' + linkData.sortCol + '&SORT_DIR=' + linkData.sortDir + '&ROWS_PER_PAGE=' + $(this).val() + '&ROW_OFFSET=' + linkData.rowOffset + '&' + linkData.searchKey + '=' + linkData.searchVal;

    });


  //listen for related events embed messages
  var $relatedEventsFrame = $('.related-events-frame');
  var acceptedDomains = ['https://www.peppermillreno.com', 'https://dev.peppermillreno.com'];
  var currentDomain = location.protocol + '//' + location.host;
  var domainToAccept = '';

  for (var i = 0, l = acceptedDomains.length; i < l; i++) {

    if (currentDomain === acceptedDomains[i]) {

      domainToAccept = acceptedDomains[i];

      break;

    }

  }

  if ($relatedEventsFrame.length) {

    if (Modernizr.postmessage && domainToAccept.length) {

      window
        .addEventListener('message', function (event) {
          if (origin.substring(0, domainToAccept.length) === domainToAccept && event.isTrusted) {
            try {
              const dataObj = JSON.parse(event.data);
              if (typeof dataObj === 'object') {
                if ('numberOfItems' in dataObj && dataObj.numberOfItems === 0) {
                  $relatedEventsFrame
                    .closest('.body-container')
                    .hide()
                    .prev('h2')
                    .hide();
                } else if ('pageHeight' in dataObj) {
                  $relatedEventsFrame
                    .css({
                      height: parseInt(dataObj.pageHeight, 10),
                      overflow: 'hidden'
                    });
                }
              }
            } catch (e) {}
          }
        }, false);

      //let each frame know that we're ready to receive data
      $.each($relatedEventsFrame, function () {
        parent
          .postMessage(
            JSON.stringify({
              ready: true
            }),
            domainToAccept
          );
      });
    } else {
      //postmessage fallback
      $relatedEventsFrame
        .css({
          height: 1000
        });
    }
  }


  //.btn-disabled CODE
  $(document)
    .on('click', '.btn-disabled', function (event) {

      event.preventDefault();

    });

})(jQuery);